import { render, staticRenderFns } from "./PageEvents.vue?vue&type=template&id=3a5672ec&"
import script from "./PageEvents.vue?vue&type=script&lang=js&"
export * from "./PageEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5672ec')) {
      api.createRecord('3a5672ec', component.options)
    } else {
      api.reload('3a5672ec', component.options)
    }
    module.hot.accept("./PageEvents.vue?vue&type=template&id=3a5672ec&", function () {
      api.rerender('3a5672ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/events/PageEvents.vue"
export default component.exports